export default __webpack_public_path__ + "static/media/1.580f4c5e.jpg";